import { RootState } from '@/store/store';
import { ModuleTree } from 'vuex';
import { courseLicenseTemplateActions } from './course-license-template.actions';
import { courseLicenseTemplateMutations } from './course-license-template.mutations';
import { courseLicenseTemplateState } from './course-license-template.state';

export default {
  namespaced: true,
  state: courseLicenseTemplateState,
  actions: courseLicenseTemplateActions,
  mutations: courseLicenseTemplateMutations
} as ModuleTree<RootState>;
